import glES from './gl/glES';

export default {
  glES: () => glES
};
